const REQUIRED_ENV_VARS = [
  'VITE_REACT_APP_DEPLOY_STAGE',
  'VITE_REACT_APP_AUTH_API',
  'VITE_REACT_APP_ORG_V2',
] as const;

export function validateEnvironment(): void {
  const missing: string[] = [];

  for (const key of REQUIRED_ENV_VARS) {
    if (!import.meta.env[key]) {
      missing.push(key);
    }
  }

  if (missing.length > 0) {
    console.warn(
      `[ENV] Missing required environment variables: ${missing.join(', ')}. ` +
      'Some features may not work correctly.'
    );
  }
}
